import {Injectable} from '@angular/core';
import {HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {RondeivuHttpClient} from "../../../handlers";
import {Observable, of} from "rxjs";
import {Store} from "@ngrx/store";
import { DealService } from '../../deals/services';
import { IDealCard } from '../../shared/models';
import { DealPreviewService } from '../../deals/services/deal-preview.service';
import { MarketingTableDto, MarketingActionHistoryUpdateDto, MarketingItemDto, InitiateMarketingDto, MarketingContactDto } from '../interafaces/marketing-dto';

@Injectable({
  providedIn: 'root'
})
export class MarketingService {

  private readonly BASE_URL = environment.rondeivu_api;
  private readonly FRAGMENT = '/marketing';
  private readonly FRAGMENT_CONTACTS = '/contacts';

  constructor(
    private store: Store, 
    // private dealService: DealService,
    private dealPreviewService: DealPreviewService,
    private http: RondeivuHttpClient) {
  }


  /**
   * Get deals based on status filter
   * @param status
   */
  getDeals(): Observable<IDealCard[]> {
    return this.dealPreviewService.getLiveDealsPreview();
  }

  getAllCampaigns(): Observable<MarketingTableDto[]> {
    return this.http.get<MarketingTableDto[]>(this.BASE_URL + this.FRAGMENT);
  }

  getAllActions(): Observable<MarketingActionHistoryUpdateDto[]> {
    return this.http.get<MarketingActionHistoryUpdateDto[]>(this.BASE_URL + this.FRAGMENT + '/actions');
  }

  getCampaignById(campaignId: string): Observable<MarketingItemDto> {
    return this.http.get<MarketingItemDto>(this.BASE_URL + this.FRAGMENT + `/${campaignId}`);
  }

  editCampaign(campaignId: string, campaignData: MarketingItemDto): Observable<MarketingItemDto> {
    return this.http.put<MarketingItemDto>(this.BASE_URL + this.FRAGMENT + `/${campaignId}`, campaignData);
  }

  createCampaign(campaignData: InitiateMarketingDto): Observable<any> {
    return this.http.post(this.BASE_URL + this.FRAGMENT, campaignData);
  }

  deleteCampaign(campaignId: string): Observable<void> {
    return this.http.delete<void>(this.BASE_URL + this.FRAGMENT + `/${campaignId}`);
  }


  // contacts 
  getAllContacts(): Observable<MarketingContactDto[]> {
    return this.http.get<MarketingContactDto[]>(this.BASE_URL + this.FRAGMENT_CONTACTS);
  }

  editContact(id: string, contactData: MarketingContactDto): Observable<MarketingContactDto> {
    return this.http.put<MarketingContactDto>(this.BASE_URL + this.FRAGMENT_CONTACTS + `/${id}`, contactData);
  }

  createContact(contactData: MarketingContactDto): Observable<MarketingContactDto> {
    return this.http.post<MarketingContactDto>(this.BASE_URL + this.FRAGMENT_CONTACTS, contactData);
  }

  deleteContact(id: string): Observable<void> {
    return this.http.delete<void>(this.BASE_URL + this.FRAGMENT_CONTACTS + `/${id}`);
  }

}
